import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState, useEffect } from "react";
import tastygit from "../sampleworks/tastygit1.png";
import plantbase from "../sampleworks/plantbase1.png";
import charmingpets from "../sampleworks/charming-pets-1.png";

const sampleProjects = [
  {
    id: 1,
    title: "TastyGit",
    description:
      "TastyGit is a free resource and reference website that is all about Git and GitHub. It aims to use as a guide for developers and also for a beginner and aspiring developers who are new to version control systems and how to utilize it in your projects.",
    technology: "HTML, CSS, Bootstrap",
    imgsrc: `${tastygit}`,
    urlLink: "https://tasty-git.vercel.app/",
  },
  {
    id: 2,
    title: "PlantBase",
    description:
      "PlantBase is a plant shop app where users can find and buy ornamental indoor and outdoor plants. It could help to promote environmental awareness and influence people to take care and be responsible of our planet by knowing how to grow and take care of plants",
    technology:
      "HTML, CSS, JavaScript, Bootstrap, PayPal API, Plant Identification API, House Plants API (via RapidAPI)",
    imgsrc: `${plantbase}`,
    urlLink: "https://group-3-nickel-capstone.vercel.app/",
  },
  {
    id: 3,
    title: "Charming Pets",
    description:
      "Charming Pets is a pet training class and adoption website. Humanity also needs to show compassion towards animals and this website aims to promote animal welfare and influence people to respect and take care of animals and pets as a member of a family.",
    technology: "React JS, PHP Laravel, EmailJS, Mailtrap, Bootstrap, MySQL",
    imgsrc: `${charmingpets}`,
    urlLink: "https://group-3-nickel-capstone.vercel.app/",
  },
];

const Slider = () => {
  // custom slider
  const [currentSlide, setCurrentSlide] = useState(0);
  const slideLength = sampleProjects.length;

  const autoScroll = true;
  let slideInterval;
  let intervalTime = 15000;

  const nextSlide = () => {
    setCurrentSlide(currentSlide === slideLength - 1 ? 0 : currentSlide + 1);
  };

  const prevSlide = () => {
    setCurrentSlide(currentSlide === 0 ? slideLength - 1 : currentSlide - 1);
  };

  function auto() {
    slideInterval = setInterval(nextSlide, intervalTime);
  }

  useEffect(() => {
    setCurrentSlide(0);
  }, []);

  useEffect(() => {
    if (autoScroll) {
      auto();
    }
    return () => clearInterval(slideInterval);
  }, [currentSlide]);

  return (
    <div className="slider relative">
      <FontAwesomeIcon
        icon={faAngleLeft}
        className="arrow prev absolute text-[#7DCE13] opacity-50 hover:opacity-100 cursor-pointer w-10 h-10 rounded-full p-2 hidden md:flex justify-center items-center z-10 md:left-0 left-0 top-[50%]"
        onClick={prevSlide}
      />
      <FontAwesomeIcon
        icon={faAngleRight}
        className="arrow next absolute text-[#7DCE13] opacity-50 hover:opacity-100 cursor-pointer w-10 h-10 rounded-full p-2 hidden md:flex justify-center items-center z-10 md:right-0 right-0 top-[50%]"
        onClick={nextSlide}
      />
      <div className="flex justify-between items-center">
        <button className="bg-[#7DCE13] text-white p-2 shadow-sm mt-10 md:hidden" onClick={prevSlide}>
          Prev
        </button>
        <button className="bg-[#7DCE13] text-white p-2 shadow-sm mt-10 md:hidden" onClick={nextSlide}>
          Next
        </button>
      </div>
      <div className="md:mx-24 md:my-10 my-4">
        {sampleProjects.map((slide, index) => {
          return (
            <div
              className={index === currentSlide ? "slide current" : "slide"}
              key={index}
            >
              {index === currentSlide && (
                <div className="md:flex md:justify-between md:items-center gap-x-10">
                  <div className="md:p-4 flex-[1]">
                    <a
                      className="text-2xl font-semibold text-[#7DCE13] underline"
                      href={slide.urlLink}
                      target="_blank"
                    >
                      {`${slide.title}`}
                    </a>
                    <p className="my-5">{slide.description}</p>
                    <p>
                      <span className="font-semibold">Technologies used:</span>
                      <br />
                      <span className="font-mono text-sm">
                        {slide.technology}
                      </span>
                    </p>
                  </div>
                  <div className="flex-[1] mt-10 md:mt-0">
                    <img className="block w-full" src={slide.imgsrc} alt="" />
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Slider;
